<template>
  <v-btn class="square-button-container"
         @mouseenter="focusTrue"
         @mouseleave="focusFalse"
         :disabled="disabled"
         :class="[size, {
         'active' : active,
         }]">
    <icon-default v-if="isActiveIcon"
                  :size="'mini'"
                  :color="active
                  ? 'white'
                  : focusParam
                  ? 'light-purple'
                   : 'purple'"
    >
      <slot/>
    </icon-default>
    <slot v-else/>
  </v-btn>
</template>

<script>

import IconDefault from "@/components/shared/icons/IconDefault.vue";

export default {
  name: "ButtonSquare",
  components: {IconDefault},
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    isActiveIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      focusParam: false
    }
  }
}
</script>

<style scoped lang="scss">
.square-button-container {
  min-width: 50px;
  width: fit-content !important;
  height: 50px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .3s ease;
  border-radius: 12px;
  box-shadow: none !important;
  border: none;
  color: rgba(var(--color-dark-green), 0.6) !important;
  letter-spacing: normal;
  background: rgba(var(--color-grey-rgba), 0.1);
  &.active {
    color: var(--color-white) !important;
    background: var(--color-dark-green);
    &:hover {
      color: var(--color-white) !important;
      background: var(--color-dark-green);
    }
  }
  &:active {
    color: var(--color-white) !important;
    background: var(--color-must-dark-purple);
  }
  &:hover {
    color: rgba(var(--color-dark-green), 0.6) !important;
    background: rgba(var(--color-grey-rgba), 0.3);
  }
}
</style>